import classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { getOfficeAccountHolder } from "../actions";
// Bootstrap
import { Button, Panel } from "react-bootstrap";
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ContactUsView.less";
const mapStateToProps = (state, ownProps) => {
    return {
        officeId: ownProps.params && ownProps.params.officeId && parseInt(ownProps.params.officeId),
        accountMangerName: state.app.contactUs.name,
        accountManagerEmail: state.app.contactUs.email,
        accountManagerMobile: state.app.contactUs.mobileNumber,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getAccountManagerDetails: (officeId) => { dispatch(getOfficeAccountHolder(officeId)); }
    };
};
class ContactUsView extends React.Component {
    componentDidMount() {
        this.props.getAccountManagerDetails(this.props.officeId);
    }
    showLiveChat() {
        zE.activate({ hideOnClose: true });
    }
    ;
    render() {
        return (React.createElement(Page, null,
            React.createElement(PageHeading, { reportName: "Contact Us" }),
            React.createElement(PageContainer, null,
                React.createElement("div", { className: styles.contents },
                    React.createElement(Panel, { className: styles.panel },
                        React.createElement(Panel.Heading, null,
                            React.createElement(Panel.Title, { componentClass: "h4" }, "Your Account Manager")),
                        React.createElement(Panel.Body, null,
                            React.createElement("div", { className: styles.field },
                                React.createElement("span", { className: styles.title }, "Name:"),
                                React.createElement("span", { className: styles.value }, this.props.accountMangerName)),
                            React.createElement("div", { className: styles.field },
                                React.createElement("span", { className: styles.title }, "Email:"),
                                React.createElement("a", { href: `mailto:${this.props.accountManagerEmail}`, className: styles.value }, this.props.accountManagerEmail)),
                            React.createElement("div", { className: styles.field },
                                React.createElement("span", { className: styles.title }, "Mobile:"),
                                React.createElement("span", { className: styles.value }, this.props.accountManagerMobile)))),
                    React.createElement("div", { className: styles.paragraph }, "Our dedicated Customer Support team is here to provide you with answers to your pressing questions."),
                    React.createElement("div", { className: styles.paragraph },
                        "Consultants are available: ",
                        React.createElement("ul", null,
                            React.createElement("li", null, "8am - 5pm on weekdays"))),
                    React.createElement("div", { className: styles.paragraph },
                        React.createElement("div", { className: styles.field },
                            React.createElement("span", { className: styles.title }, "Telephone:"),
                            React.createElement("a", { href: `tel:${callCentreNumber}`, className: styles.value }, callCentreNumberText)),
                        React.createElement("div", { className: styles.field },
                            React.createElement("span", { className: styles.title }, "Email:"),
                            React.createElement("a", { href: `mailto:${callCentreEmail}`, className: styles.value }, callCentreEmail)),
                        React.createElement("div", { className: styles.field },
                            React.createElement("span", { className: styles.title }, "Live Chat: "),
                            React.createElement(Button, { className: classNames(styles.value, "btn btn-sm btn-info"), onClick: () => this.showLiveChat() },
                                React.createElement("span", { className: "fa fa-comment" }),
                                "Chat with a consultant")))))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactUsView);
